import { Component, AfterViewInit, ViewChild, ElementRef, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { LocaService } from '../../../service/loca/loca.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';


@Component({
  selector: 'wa0030',
  templateUrl: 'wa0030.component.html',
  styleUrls: ['wa0030.component.scss']
})
export class Wa0030Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA0030:ロケ選択';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isEnableClearFilter = false;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  constructor(private router: Router, private locaService: LocaService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa0030_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
        this.gridHelper.renderGridCheckboxImage();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };


    this.gridOptions.columnDefs = [
      {
        headerName: '',
        width: 30,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus'],
        checkboxSelection: true, suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: 'ロケコード',
        field: 'locaCd',
        sort: 'asc',
        width: this.getColumnWidth('locaCd', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        width: this.getColumnWidth('locaTx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケバーコード',
        field: 'locabarcodeTx',
        width: this.getColumnWidth('locabarcodeTx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '温度帯区分',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケブロック',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷頻度ABC',
        field: 'locaabcTx',
        width: this.getColumnWidth('locaabcTx', 110),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷優先順位',
        field: 'arrivepriorityNr',
        width: this.getColumnWidth('arrivepriorityNr', 110),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷優先順位',
        field: 'shippriorityNr',
        width: this.getColumnWidth('shippriorityNr', 110),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷不可フラグ',
        field: 'notarriveTx',
        width: this.getColumnWidth('notarriveTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        valueGetter: function (params) {
          if (params.data.notarriveFl === 0) {
            return '可';
          } else {
            return '不可';
          }
        }
      },
      {
        headerName: '出荷不可フラグ',
        field: 'notshipTx',
        width: this.getColumnWidth('notshipTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        valueGetter: function (params) {
          if (params.data.notshipFl === 0) {
            return '可';
          } else {
            return '不可';
          }
        }
      },
      {
        headerName: '商品混載可フラグ',
        field: 'mixitemTx',
        width: this.getColumnWidth('mixitemTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        valueGetter: function (params) {
          if (params.data.mixitemFl === 1) {
            return '可';
          } else {
            return '不可';
          }
        }
      },
      {
        headerName: 'ロット混載可フラグ',
        field: 'mixlotTx',
        width: this.getColumnWidth('mixlotTx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        valueGetter: function (params) {
          if (params.data.mixlotFl === 1) {
            return '可';
          } else {
            return '不可';
          }
        }
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa0030_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa0030_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa0030_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    this.working = true;
    this.locaService
      .get()
      .then(outputJson => {

        this.rowData = outputJson.locas;
        this.working = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working = false;
      });
  }

  onSelect() {
    if (this.selectedCount != 1)
      return;

    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    this.closeButtonClick.emit(this.rowData[selectedIndex]);
  }
  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    this.closeButtonClick.emit(null);
  }

  initDatas() {
    this.gridOptions.api.deselectAll();
    this.gridOptions.api.setFilterModel(null);
    this.onSubmit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0030/wa0030.component.ts